var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreCulture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.678,
    height: 66.044,
    viewBox: "0 0 57.678 66.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_63",
    transform: "translate(-0.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46778",
    "data-name": "Group 46778",
    transform: "translate(0.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46668",
    "data-name": "Group 46668",
    transform: "translate(13.562 18.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46667",
    "data-name": "Group 46667"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2743",
    "data-name": "Ellipse 2743",
    cx: 14.955,
    cy: 14.955,
    rx: 14.955,
    ry: 14.955,
    fill: "#097fa8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46670",
    "data-name": "Group 46670",
    transform: "translate(24.954 0.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46669",
    "data-name": "Group 46669"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2744",
    "data-name": "Ellipse 2744",
    cx: 3.563,
    cy: 3.563,
    rx: 3.563,
    ry: 3.563,
    fill: "#feb872"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46672",
    "data-name": "Group 46672",
    transform: "translate(22.375 8.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46671",
    "data-name": "Group 46671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54248",
    "data-name": "Path 54248",
    d: "M113.368,32.976H107.3a3.117,3.117,0,0,0-3.108,3.108v2.141a1.139,1.139,0,0,0,1.14,1.14h10.006a1.139,1.139,0,0,0,1.14-1.14V36.084A3.118,3.118,0,0,0,113.368,32.976Z",
    transform: "translate(-104.191 -32.976)",
    fill: "#fc657e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46674",
    "data-name": "Group 46674",
    transform: "translate(24.954 58.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46673",
    "data-name": "Group 46673"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2745",
    "data-name": "Ellipse 2745",
    cx: 3.563,
    cy: 3.563,
    rx: 3.563,
    ry: 3.563,
    fill: "#a57453"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46676",
    "data-name": "Group 46676",
    transform: "translate(22.374 51.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46675",
    "data-name": "Group 46675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54249",
    "data-name": "Path 54249",
    d: "M115.336,198.262H105.33a1.139,1.139,0,0,0-1.14,1.14v2.141a3.117,3.117,0,0,0,3.108,3.108h6.069a3.117,3.117,0,0,0,3.108-3.108V199.4A1.139,1.139,0,0,0,115.336,198.262Z",
    transform: "translate(-104.19 -198.262)",
    fill: "#f5c84c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46678",
    "data-name": "Group 46678",
    transform: "translate(0 15.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46677",
    "data-name": "Group 46677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54250",
    "data-name": "Path 54250",
    d: "M22.806,58.821a3.563,3.563,0,1,0,1.3,4.867A3.563,3.563,0,0,0,22.806,58.821Z",
    transform: "translate(-17.462 -58.343)",
    fill: "#f9d0b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46680",
    "data-name": "Group 46680",
    transform: "translate(5.356 16.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46679",
    "data-name": "Group 46679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54251",
    "data-name": "Path 54251",
    d: "M47.769,65.772,45.915,64.7a3.117,3.117,0,0,0-4.245,1.137l-3.034,5.256a3.117,3.117,0,0,0,1.137,4.245l1.854,1.07a1.139,1.139,0,0,0,1.556-.417l5-8.666A1.139,1.139,0,0,0,47.769,65.772Z",
    transform: "translate(-38.221 -64.287)",
    fill: "#5290db"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46682",
    "data-name": "Group 46682",
    transform: "translate(49.908 43.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46681",
    "data-name": "Group 46681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54252",
    "data-name": "Path 54252",
    d: "M216.26,170.512a3.563,3.563,0,1,0,1.3,4.867A3.563,3.563,0,0,0,216.26,170.512Z",
    transform: "translate(-210.916 -170.034)",
    fill: "#d68649"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46684",
    "data-name": "Group 46684",
    transform: "translate(41.561 37.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46683",
    "data-name": "Group 46683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54253",
    "data-name": "Path 54253",
    d: "M187.126,145.351l-1.854-1.07a1.139,1.139,0,0,0-1.556.417l-5,8.666a1.139,1.139,0,0,0,.417,1.556l1.854,1.07a3.117,3.117,0,0,0,4.245-1.137l3.035-5.256A3.117,3.117,0,0,0,187.126,145.351Z",
    transform: "translate(-178.559 -144.127)",
    fill: "#fca265"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46686",
    "data-name": "Group 46686",
    transform: "translate(0 43.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46685",
    "data-name": "Group 46685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54254",
    "data-name": "Path 54254",
    d: "M24.11,171.815a3.563,3.563,0,1,0-1.3,4.867A3.563,3.563,0,0,0,24.11,171.815Z",
    transform: "translate(-17.462 -170.033)",
    fill: "#fce4be"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46688",
    "data-name": "Group 46688",
    transform: "translate(5.356 37.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46687",
    "data-name": "Group 46687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54255",
    "data-name": "Path 54255",
    d: "M48.186,153.363l-5-8.666a1.139,1.139,0,0,0-1.556-.417l-1.854,1.07a3.117,3.117,0,0,0-1.137,4.245l3.035,5.256a3.117,3.117,0,0,0,4.245,1.137l1.854-1.07A1.139,1.139,0,0,0,48.186,153.363Z",
    transform: "translate(-38.221 -144.127)",
    fill: "#70d6f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46690",
    "data-name": "Group 46690",
    transform: "translate(49.908 15.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46689",
    "data-name": "Group 46689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54256",
    "data-name": "Path 54256",
    d: "M217.563,60.125a3.563,3.563,0,1,0-1.3,4.867A3.563,3.563,0,0,0,217.563,60.125Z",
    transform: "translate(-210.915 -58.343)",
    fill: "#818182"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46692",
    "data-name": "Group 46692",
    transform: "translate(41.561 16.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46691",
    "data-name": "Group 46691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54257",
    "data-name": "Path 54257",
    d: "M188.263,71.095l-3.035-5.256a3.117,3.117,0,0,0-4.245-1.137l-1.854,1.07a1.14,1.14,0,0,0-.417,1.556l5,8.666a1.139,1.139,0,0,0,1.556.417l1.854-1.07A3.117,3.117,0,0,0,188.263,71.095Z",
    transform: "translate(-178.559 -64.287)",
    fill: "#87d147"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46695",
    "data-name": "Group 46695",
    transform: "translate(12.917 17.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46694",
    "data-name": "Group 46694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46693",
    "data-name": "Group 46693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54258",
    "data-name": "Path 54258",
    d: "M83.132,67.532a15.6,15.6,0,1,0,15.6,15.6A15.618,15.618,0,0,0,83.132,67.532Zm0,29.91a14.31,14.31,0,1,1,14.31-14.31A14.326,14.326,0,0,1,83.132,97.442Z",
    transform: "translate(-67.532 -67.532)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46697",
    "data-name": "Group 46697",
    transform: "translate(19.686 17.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46696",
    "data-name": "Group 46696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54259",
    "data-name": "Path 54259",
    d: "M95.058,84.544c0-5.9,1.7-11.395,4.319-14.007a.645.645,0,0,0-.91-.914c-2.9,2.886-4.7,8.6-4.7,14.921,0,6.278,1.784,11.979,4.656,14.877a.645.645,0,1,0,.916-.908C96.7,95.847,95.058,90.495,95.058,84.544Z",
    transform: "translate(-93.768 -69.435)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46699",
    "data-name": "Group 46699",
    transform: "translate(31.549 17.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46698",
    "data-name": "Group 46698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54260",
    "data-name": "Path 54260",
    d: "M140.853,69.623a.645.645,0,0,0-.91.914c2.624,2.612,4.319,8.111,4.319,14.007,0,5.88-1.689,11.371-4.3,13.99a.645.645,0,0,0,.913.911c2.886-2.892,4.679-8.6,4.679-14.9C145.552,78.226,143.752,72.509,140.853,69.623Z",
    transform: "translate(-139.753 -69.435)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46701",
    "data-name": "Group 46701",
    transform: "translate(13.418 36.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46700",
    "data-name": "Group 46700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54261",
    "data-name": "Path 54261",
    d: "M99.462,139.947a.646.646,0,0,0-.912,0c-2.666,2.642-8.019,4.283-13.97,4.283-5.9,0-11.395-1.7-14.007-4.319a.645.645,0,0,0-.914.91c2.886,2.9,8.6,4.7,14.921,4.7,6.278,0,11.979-1.784,14.877-4.656A.645.645,0,0,0,99.462,139.947Z",
    transform: "translate(-69.472 -139.715)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46703",
    "data-name": "Group 46703",
    transform: "translate(13.418 24.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46702",
    "data-name": "Group 46702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54262",
    "data-name": "Path 54262",
    d: "M99.482,98.41c-2.892-2.886-8.6-4.679-14.9-4.679-6.318,0-12.035,1.8-14.921,4.7a.645.645,0,1,0,.914.91c2.612-2.624,8.111-4.319,14.007-4.319,5.88,0,11.371,1.689,13.989,4.3a.645.645,0,0,0,.911-.913Z",
    transform: "translate(-69.473 -93.731)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46705",
    "data-name": "Group 46705",
    transform: "translate(27.872 17.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46704",
    "data-name": "Group 46704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54263",
    "data-name": "Path 54263",
    d: "M126.145,68.543a.645.645,0,0,0-.645.645V98.576a.645.645,0,0,0,1.29,0V69.188A.645.645,0,0,0,126.145,68.543Z",
    transform: "translate(-125.5 -68.543)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46707",
    "data-name": "Group 46707",
    transform: "translate(13.178 32.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46706",
    "data-name": "Group 46706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54264",
    "data-name": "Path 54264",
    d: "M98.576,125.5H69.188a.645.645,0,0,0,0,1.29H98.576a.645.645,0,0,0,0-1.29Z",
    transform: "translate(-68.543 -125.5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46710",
    "data-name": "Group 46710",
    transform: "translate(24.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46709",
    "data-name": "Group 46709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46708",
    "data-name": "Group 46708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54265",
    "data-name": "Path 54265",
    d: "M115.9,0a4.208,4.208,0,1,0,4.208,4.208A4.212,4.212,0,0,0,115.9,0Zm0,7.125a2.918,2.918,0,1,1,2.918-2.918A2.921,2.921,0,0,1,115.9,7.125Z",
    transform: "translate(-111.69)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46713",
    "data-name": "Group 46713",
    transform: "translate(21.73 7.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46712",
    "data-name": "Group 46712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46711",
    "data-name": "Group 46711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54266",
    "data-name": "Path 54266",
    d: "M111.513,30.477h-6.069a3.757,3.757,0,0,0-3.753,3.753v2.141a1.786,1.786,0,0,0,1.784,1.784h10.006a1.787,1.787,0,0,0,1.784-1.784V34.23A3.757,3.757,0,0,0,111.513,30.477Zm2.463,5.893a.5.5,0,0,1-.495.495H103.475a.5.5,0,0,1-.495-.495V34.23a2.466,2.466,0,0,1,2.463-2.463h6.069a2.465,2.465,0,0,1,2.463,2.463V36.37Z",
    transform: "translate(-101.691 -30.477)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46760",
    "data-name": "Group 46760",
    transform: "translate(49.265 14.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46759",
    "data-name": "Group 46759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46758",
    "data-name": "Group 46758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54285",
    "data-name": "Path 54285",
    d: "M216.272,57.944a4.206,4.206,0,1,0-1.54,5.747A4.181,4.181,0,0,0,216.272,57.944Zm-2.185,4.631a2.918,2.918,0,1,1,1.068-3.986A2.922,2.922,0,0,1,214.087,62.575Z",
    transform: "translate(-208.422 -55.838)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46763",
    "data-name": "Group 46763",
    transform: "translate(40.915 15.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46762",
    "data-name": "Group 46762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46761",
    "data-name": "Group 46761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54286",
    "data-name": "Path 54286",
    d: "M186.965,68.913l-3.035-5.256a3.758,3.758,0,0,0-5.127-1.374l-1.854,1.07a1.784,1.784,0,0,0-.653,2.437l5,8.666a1.785,1.785,0,0,0,2.437.653l1.854-1.07A3.757,3.757,0,0,0,186.965,68.913Zm-.875,2.513a2.445,2.445,0,0,1-1.144,1.5l-1.854,1.07a.495.495,0,0,1-.675-.181l-5-8.666a.5.5,0,0,1,.181-.675l1.854-1.07a2.465,2.465,0,0,1,3.365.9l3.035,5.256A2.445,2.445,0,0,1,186.09,71.426Z",
    transform: "translate(-176.057 -61.781)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46769",
    "data-name": "Group 46769",
    transform: "translate(45.576 52.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46768",
    "data-name": "Group 46768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54289",
    "data-name": "Path 54289",
    d: "M197.421,205.618a2.011,2.011,0,0,1-1.6-1.574c0-.026-.077-.026-.077,0a2.011,2.011,0,0,1-1.6,1.574c-.026,0-.026.052,0,.077a2.011,2.011,0,0,1,1.6,1.574c0,.026.077.026.077,0a2.011,2.011,0,0,1,1.6-1.574C197.447,205.67,197.447,205.618,197.421,205.618Z",
    transform: "translate(-194.125 -204.025)",
    fill: "#87d147"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46771",
    "data-name": "Group 46771",
    transform: "translate(36.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46770",
    "data-name": "Group 46770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54290",
    "data-name": "Path 54290",
    d: "M163.385,1.419h-.619V.826A.815.815,0,0,0,161.941,0a.826.826,0,0,0-.826.8v.619h-.593a.815.815,0,0,0-.826.826.8.8,0,0,0,.826.826h.593v.593a.815.815,0,0,0,.826.826.826.826,0,0,0,.826-.8V3.07h.593a.815.815,0,0,0,.826-.826A.826.826,0,0,0,163.385,1.419Z",
    transform: "translate(-159.695)",
    fill: "#fc657e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46773",
    "data-name": "Group 46773",
    transform: "translate(19.462 64.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46772",
    "data-name": "Group 46772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54291",
    "data-name": "Path 54291",
    d: "M93.777,249.2a.877.877,0,1,0,.877.877A.877.877,0,0,0,93.777,249.2Z",
    transform: "translate(-92.9 -249.2)",
    fill: "#70d6f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46775",
    "data-name": "Group 46775",
    transform: "translate(42.68 6.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46774",
    "data-name": "Group 46774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54292",
    "data-name": "Path 54292",
    d: "M183.777,27a.877.877,0,1,0,.877.877A.877.877,0,0,0,183.777,27Z",
    transform: "translate(-182.9 -27)",
    fill: "#f5c84c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46777",
    "data-name": "Group 46777",
    transform: "translate(12.664 56.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46776",
    "data-name": "Group 46776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54293",
    "data-name": "Path 54293",
    d: "M71.284,222.633a2.863,2.863,0,0,1-2.3-2.244c0-.052-.1-.052-.1,0a2.863,2.863,0,0,1-2.3,2.244c-.052,0-.052.077,0,.1a2.863,2.863,0,0,1,2.3,2.244c0,.052.1.052.1,0a2.863,2.863,0,0,1,2.3-2.244C71.336,222.711,71.336,222.633,71.284,222.633Z",
    transform: "translate(-66.55 -220.35)",
    fill: "#f5c84c"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreCulture);
export default __webpack_public_path__ + "static/media/explore-culture.394cfef4580035a0038c32d7327bcfb4.svg";
export { ForwardRef as ReactComponent };